import React, { useEffect, useState, useContext } from "react";
import SectionCard from "../components/SectionCard";
import { Label, Input } from "../components/FormControls";
import { BadgePercent } from "lucide-react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../../Context/GlobalContext";

import useOrderSettings from "../../../Services/OrderServices/OrderSettingsServices/useOrderSettings";

export default function LoyaltySection({ userID }) {
  const {getMerchantLoyaltyPointsConfig, updateMerchantLoyaltyPointsConfig}=useOrderSettings();

  const { api } = useContext(GlobalContext);
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ points: "", value: "" });

 const load = async () => {
  if (!userID) return;

  try {
    const result =
      await getMerchantLoyaltyPointsConfig(userID);

    if (result.success) {
      setList(result.data);
    } else {
      setList([]);
      // optional:
      // toast.error(result.message);
    }
  } catch {
    setList([]);
  }
};


const save = async () => {
  if (!form.points || !form.value)
    return toast.error(
      "Fill points and value"
    );

  try {
    const result =
      await updateMerchantLoyaltyPointsConfig({
        userid: userID,
        points: Number(form.points),
        value: Number(form.value),
      });

    if (result.success) {
      toast.success(result.message);

      setForm({
        points: "",
        value: "",
      });

      load();
    } else {
      toast.error(result.message);
    }
  } catch {
    toast.error("Failed");
  }
};


  useEffect(() => { load(); }, [userID]); // eslint-disable-line

  return (
    <>
      {!!list.length && (
        <SectionCard icon={BadgePercent} title="Current Loyalty Points">
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            {list.map((l, idx) => (
              <div key={idx} className="rounded-xl border border-gray-100 bg-white p-4 text-sm shadow-sm">
                <div className="grid grid-cols-3 gap-3">
                  <div><div className="font-medium text-gray-900">{l.points}</div><div className="text-gray-500">Points</div></div>
                  <div><div className="font-medium text-gray-900">₹{Number(l.value).toFixed(2)}</div><div className="text-gray-500">Value</div></div>
                  <div><div className="font-medium text-gray-900">{l.created_on}</div><div className="text-gray-500">Created</div></div>
                </div>
              </div>
            ))}
          </div>
        </SectionCard>
      )}

      <SectionCard icon={BadgePercent} title="Update Loyalty Points">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div><Label>Loyalty Points</Label><Input value={form.points} onChange={(e)=>setForm(s=>({...s,points:e.target.value}))} /></div>
          <div><Label>Value (₹)</Label><Input value={form.value} onChange={(e)=>setForm(s=>({...s,value:e.target.value}))} /></div>
        </div>
        <div className="mt-4">
          <button onClick={save} className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700">
            Save
          </button>
        </div>
      </SectionCard>
    </>
  );
}
